// 整理引擎的兩條路
//
//   api        — 站台直接呼叫 Anthropic API（原本的行為）。給沒有 Claude Code 的人用，按次計費。
//   claude-code — 站台只組指令，整理在 Claude Code 終端機做（吃月費），結果回寫 D1。
//
// 存 localStorage：這是「這台裝置怎麼工作」的偏好，不是會議資料，
// 所以不進 D1（跨裝置各自選各自的即可）。

export type EngineMode = "api" | "claude-code";

const KEY = "chillmeet_engine_mode";

export function getEngineMode(): EngineMode {
  if (typeof localStorage === "undefined") return "api";
  return localStorage.getItem(KEY) === "claude-code" ? "claude-code" : "api";
}

export function setEngineMode(mode: EngineMode) {
  localStorage.setItem(KEY, mode);
}

export interface CommandInput {
  meetingId: string;
  title: string;
  clientName?: string | null;
  meetingDate?: string | null;
  sourceType: "plaud" | "audio" | "manual" | "mixed";
  plaudUrl?: string | null;
  refCount: number;
  hasAudio?: boolean;
}

const SOP_LINE =
  "請先讀 MineShine.app/MineShine-ChillMeet/CLAUDE.md 的〈Claude Code 整理 SOP〉，照那份流程做完（取料 → 整理 → 回寫）。";

/** 首次整理用的指令塊 */
export function buildGenerateCommand(input: CommandInput): string {
  const lines = [
    "【麥開會整理】",
    `meeting: ${input.meetingId}`,
    `title: ${input.title}`,
  ];
  if (input.clientName) lines.push(`client: ${input.clientName}`);
  if (input.meetingDate) lines.push(`date: ${input.meetingDate}`);
  lines.push(`source: ${input.sourceType}`);
  if (input.sourceType === "plaud" && input.plaudUrl) {
    lines.push(`plaud: ${input.plaudUrl}`);
  }
  if (input.sourceType === "audio") {
    lines.push("audio: 已上傳到 R2，先跑 transcribe 再整理");
  }
  lines.push(`refs: ${input.refCount} 筆`);
  lines.push("");
  lines.push(SOP_LINE);
  return lines.join("\n");
}

/** 對話迭代（微調 / 提問）用的指令塊 */
export function buildRefineCommand(
  meetingId: string,
  message: string,
  mode: "refine" | "qa",
): string {
  return [
    mode === "qa" ? "【麥開會提問】" : "【麥開會修改】",
    `meeting: ${meetingId}`,
    `mode: ${mode}`,
    "",
    mode === "qa" ? "問題：" : "指示：",
    message.trim(),
    "",
    SOP_LINE,
  ].join("\n");
}

/** 複製到剪貼簿；navigator.clipboard 在非 https 或權限被擋時會失敗，退回 execCommand */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
